import React, { ReactNode } from 'react';
import { Flags } from 'react-feature-flags';
import { SecondaryButton } from '@JohnLewisPartnership/jl-design-system/dist/elements/button/Button';
import styles from './ViewMyWishListButton.module.scss';
import { navigate } from '../../helpers/redirect/redirect';
import { WISH_LIST } from '../../helpers/redirect/constants';
import { FEATURE_FLAGS } from '../../helpers/featureFlags/constants';
import { trackEvent } from '../../helpers/monetate/monetate';
import { WISHLIST_CONFIRMATION_LINK_CLICK_EVENT_KEY } from '../../stores/constants';
import { isGuestUser } from '../../helpers/wishList/utils';

const redirectToWishList = (): void => {
    trackEvent(WISHLIST_CONFIRMATION_LINK_CLICK_EVENT_KEY);
    let wishListRedirectURL = `${process.env.REACT_APP_WISH_LIST_REDIRECT_URL}${WISH_LIST}`;
    if (isGuestUser()) {
        wishListRedirectURL = `${process.env.REACT_APP_BASE_REDIRECT_URL}${WISH_LIST}/guest`;
    }

    navigate(wishListRedirectURL);
};

export const ViewWishListButton: React.FC<ViewWishListButtonProperties> = (props: ViewWishListButtonProperties) => {
    return (
        <div className={styles.viewMyWishListButton}>
            <Flags
                authorizedFlags={[FEATURE_FLAGS.NURSERY_PROTOTYPE]}
                renderOn={(): ReactNode => (
                    <SecondaryButton
                        data-testid="view-my-wish-list-button"
                        onClick={(): void => navigate('/checklist/prototype/wishlist')}
                        className={styles.viewWishListButton}
                    >
                        {props.hasMoreThanOneList ? 'View my baby wish lists' : 'View my baby wish list'}
                    </SecondaryButton>
                )}
                renderOff={(): ReactNode => (
                    <SecondaryButton
                        data-testid="view-my-wish-list-button"
                        onClick={(): void => redirectToWishList()}
                        className={styles.viewWishListButton}
                    >
                        {props.hasMoreThanOneList ? 'View my wish lists' : 'View my wish list'}
                    </SecondaryButton>
                )}
            />
        </div>
    );
};

interface ViewWishListButtonProperties {
    hasMoreThanOneList: boolean;
}
